import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './Login';
import AdminPanel from './AdminPanel';
import FormGenerator from './FormGenerator';
import SavedSheets from './SavedSheets';
import ConcertDatesPage from './ConcertDatesPage';
import ProtectedRoute from './ProtectedRoute';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" /> : <Login />} 
      />
      
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <FormGenerator />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/sheets" 
        element={
          <ProtectedRoute>
            <SavedSheets />
          </ProtectedRoute>
        } 
      />

      {/* Public concert dates page - no auth */}
      <Route path="/concerts/:pageId" element={<ConcertDatesPage />} />
      
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute adminOnly>
            <AdminPanel />
          </ProtectedRoute>
        } 
      />
      
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
